import type { DirectiveBinding } from 'vue'

const lazyLoadDirective = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    const options = {
      root: null, // container element (null for default viewport)
      threshold: 0 // trigger callback when 10% of the image is visible
    }

    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target as HTMLImageElement
          img.src = binding.value
          imageObserver.unobserve(img)
        }
      })
    }, options)

    imageObserver.observe(el)
  }
}

export default lazyLoadDirective
